module.exports = __webpack_public_path__ + "static/img/case_detail_13_1.f203fa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_13_1.png
// module id = DYKM
// module chunks = 34